<template>
<div>
  <router-link :to="'/single/'+item.id">
    <button  class="btn-4">
      <div  class="overflow-hidden button-entry">
        <v-img

            class="image-zoom"
            style="margin: 0 10px"
            cover
            :src="item.photo_file"
            height="222"
        >
        </v-img>
        <p  style="font-size: 0.9rem" class="text-center mt-4 grey--text">
          {{item.date}}
        </p>
        <h5 v-html="item.title" class="px-4">

        </h5>
        <span class="right-border"></span>
        <span class="left-border"></span>
      </div>
    </button>
  </router-link>

</div>
</template>

<script>
export default {
  name: "NewsItem",
  props:{
    item:Object,
  }
}
</script>

<style scoped>
button {
  display: inline-block;
  position: relative;
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  margin: auto;
  width: 100%;
  height: 302px;
}

.right-border {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-right: 10px solid #f3c303;
  border-bottom: 10px solid #f3c303;
}

.left-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
  border-left: 10px solid #f3c303;
  border-top: 10px solid #f3c303;
  z-index: 97;
}


button::before, button::after {
  content: "";
  width: 0;
  height: 10px;
  position: absolute;
  transition: all 0.4s linear;
  background: #FCC300;

}

.button-entry::before, .button-entry::after {
  content: "";
  width: 10px;
  height: 0;
  position: absolute;
  transition: all 0.4s linear;
  background: #FCC300;
  z-index: 97;
}

button:hover::before, button:hover::after {
  width: 100%;
}

button:hover .button-entry::before, button:hover .button-entry::after {
  height: 100%;
}


/*----- button 4 -----*/
.btn-4::after {
  right: 0;
  bottom: 0;
  transition-duration: 0.4s;
}

.btn-4 .button-entry::after {
  right: 0;
  bottom: 0;
  transition-duration: 0.4s;
}

.btn-4::before {
  left: 0;
  top: 0;
  transition-duration: 0.4s;
}

.btn-4 .button-entry::before {
  left: 0;
  top: 0;
  transition-duration: 0.4s;
}

*, *:after, *:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

h5{
  font-size: 1.1rem;
  font-weight: bold;
}

@media screen and (max-width: 960px){
  .slide-box{
    display: table;
    background: rgba(0, 0, 0, 0.09);
    position: relative;
    margin: 0;
    width: 100%;
    height: 1500px;
    -webkit-clip-path: polygon(100% 0, 100% 98%, 0 100%, 0 0);
    clip-path: polygon(100% 0, 100% 98%, 0 100%, 0 0);
    padding-top: 16px;
  }
  .load-more {
    position: absolute;
    width: 60vw;
    margin: auto 20vw;
    bottom: 84px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background: #f3c303;
  }
  h5{
    font-size: 16px;
  }
}
@media screen and (min-width: 960px){
  .slide-box{
    display: table;
    background: rgba(0, 0, 0, 0.09);
    position: relative;
    margin: 0;
    width: 100%;
    height: 500px;
    -webkit-clip-path: polygon(100% 0, 100% 88%, 0 100%, 0 0);
    clip-path: polygon(100% 0, 100% 88%, 0 100%, 0 0);
    padding-top: 16px;
  }
  .load-more {
    position: absolute;
    width: 20vw;
    margin: auto 40vw;
    bottom: 80px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    font-weight: bold;
    cursor: pointer;
    background: #f3c303;
  }
}
</style>